import request from '@/utils/request'

//Login
export function activators(page) {
  return request({ url: 'ai/activators', method: 'post', data: {'page': page} })
} 

export function activateConfirm(data) {
  return request({ url: 'ai/activateConfirm', method: 'post', data })
}

export function activateSave(data) {
  return request({ url: 'ai/activateSave', method: 'post', data })
}
